<app-mazars-display-dialog #validationResultDialog [okBtnText]="l('Close')" [title]="title" [uid]="'validation-result-dialog'" >
    <mazars-validation-result #validationResult [uid]="uid + 'validation-result'" [showSuccessMessage]="showSuccessMessage" ></mazars-validation-result>
</app-mazars-display-dialog>
